import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedCompsModule } from '../shared/shared-comps.module';
import { AboutBeachwatchComponent } from './about-beachwatch/about-beachwatch.component';
import { ContentDataSourcesComponent } from './content-data-sources/content-data-sources.component';
import { SafeToSwimComponent } from './safe-to-swim/safe-to-swim.component';
import { RouterModule } from '@angular/router';
import { WhatIsBeachwatchComponent } from './what-is-beachwatch.component';


@NgModule({
	declarations: [
		AboutBeachwatchComponent, 
		ContentDataSourcesComponent, 
		SafeToSwimComponent, 
		WhatIsBeachwatchComponent
	],
	imports: [
		CommonModule,
		SharedCompsModule,
		RouterModule,
		SharedCompsModule
	],
	exports : [
		AboutBeachwatchComponent, 
		ContentDataSourcesComponent, 
		SafeToSwimComponent, 
		WhatIsBeachwatchComponent
	]
})
export class WhatIsBeachwatchModule { }
